module.exports = __webpack_public_path__ + "static/sport/out5.4168cb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ldp/out5.png
// module id = tZxt
// module chunks = 0